import * as jsxRuntime from "/Users/quinscacheri/dev/axiotl/convergence-2/apps/tinker/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment